import React, { Component, useState, useEffect } from "react";

export class Loading extends Component {
  continue = (e) => {
    //window.alert("this");
    //e.preventDefault();
    this.props.nextStep();
  };

  previous = (e) => {
    e.preventDefault();
    this.props.prevStep();
  };

  componentDidMount() {
    window.scrollTo(0, 0)
  }

  render() {

    if(!this.props.isFinalStep){
      const { values } = this.props;
      let diff = values.movingDate - new Date();
      let isMoveWithin7Days = diff <= 604800000;  //Diff in 7 Days in millisecond
      if(isMoveWithin7Days && values.isLocalMove){
        setTimeout(() => {
          this.props.nextStep()
        }, 5000);
      }  
    }
    
    return (
      <div className="ob-bg">
        <div className="ob-loading">
          <h2 className="ob-loading__heading ob-h2">{this.props.loadingText}</h2>
          <p className="ob-loading__message">This may take a moment.</p>
          <div className="ob-loading__container">
            <div className="ob-loading__spinner">
              <div className="loading-spinner__gradient"></div>
              <div className="loading-spinner__inner"></div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Loading;
